import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { observer } from 'mobx-react'
import React from 'react'
import { ScopeChangeInventoryItem } from '../../RequestScopeChangesViewModel'
import cx from 'classnames'
import styles from './ScopeChangeInventoryItem.sass'
import Checkbox from 'components/Checkbox'

export default observer(function ScopeChangeInventoryItem({
  item,
  updateQuantity,
}: {
  item: ScopeChangeInventoryItem
  updateQuantity?: boolean
}) {
  if (updateQuantity) {
    return <ScopeChangeInventoryItemUpdateQuantity item={item} />
  }

  return <ScopeChangeInventoryItemSelection item={item} />
})

const ScopeChangeInventoryItemUpdateQuantity = observer(
  function ScopeChangeInventoryItemUpdateQuantity({
    item,
  }: {
    item: ScopeChangeInventoryItem
  }) {
    return (
      <div className={cx(styles.itemContainer)}>
        <IconButton
          className={styles.removeItemButton}
          onClick={() => item.toggle()}
          dataTest={`request-scope-changes-inventory-remove-button-${item.name}`}
        >
          <Icon name="close" size={24} />
        </IconButton>

        <div className={styles.textContainer}>
          <div className={styles.title}>{item.name}</div>
          <div className={styles.description}>{item.description}</div>
        </div>

        <div className={styles.currentQuantityContainer}>
          {item.currentQuantity}
        </div>

        <div
          className={cx(
            styles.itemQuantityContainer,
            item.validation.getError('newQuantity') && styles.hasError,
          )}
        >
          <IconButton>
            <Icon name="subtract" size={16} onClick={item.decrementQuantity} />
          </IconButton>

          <input
            key="quantity"
            type="number"
            min="1"
            className={cx(styles.input, styles.itemQuantity)}
            value={item.newQuantity}
            onChange={(e) => item.setQuantity(e.target.value)}
            data-test={`scope-change-inventory-quantity-${item.name}`}
          />

          <IconButton onClick={item.incrementQuantity}>
            <Icon name="add" size={16} />
          </IconButton>
        </div>
      </div>
    )
  },
)

const ScopeChangeInventoryItemSelection = observer(
  function ScopeChangeInventoryItemSelection({
    item,
  }: {
    item: ScopeChangeInventoryItem
  }) {
    return (
      <div
        className={cx(styles.itemContainer, item.selected && styles.selected)}
        onClick={() => item.toggle()}
        data-test={`scope-change-inventory-item-${item.name}`}
      >
        <div className={styles.checkboxContainer}>
          <Checkbox checked={item.selected} />
        </div>

        <div className={styles.textContainer}>
          <div className={styles.title}>{item.name}</div>
          <div className={styles.description}>{item.description}</div>
        </div>
      </div>
    )
  },
)
